import { useState } from "react";
import { Button, Row } from "react-bootstrap";
import { useLazyGetQuizGroupOpenChallengesQuery } from "../../slices/fun_stuff/quizGroupsSlice";
import { useCreateChallengeMutation } from "../../slices/fun_stuff/quizGroupsSlice";
import { useLoadQuizChallenges } from '../../hooks/useLoadQuizChallenges';
import { useLoadQuizGroups } from "../../hooks/useLoadQuizGroups";
import { useSocket } from "../../context/SocketContext";
import { toast } from "react-toastify";
import Loader from "../Loader";
import QuizLink from "./QuizLink";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faPlus } from '@fortawesome/free-solid-svg-icons';

const levels = {
    'elementary': 'Elementary',
    'high school': 'High School',
    'honors': 'Honors',
    'university': 'University',
};

const GroupChallenges = (( { quizUserInfo, group, index, showGroup, setShowGroup, challengeGroupId, setChallengeGroupId }) => {    
    const socket = useSocket();

    const [eligibleQuizzes, setEligibleQuizzes] = useState([{}]);
    const [showChallengeDiv, setShowChallengeDiv] = useState(false);

    const [getGroupOpenChallenges, { isLoading: openChallengeLoading }] = useLazyGetQuizGroupOpenChallengesQuery();
    const [createChallenge, {isLoading: createChallengeLoading}] = useCreateChallengeMutation();

    const { loadGroups } = useLoadQuizGroups();
    const { loadChallenges } = useLoadQuizChallenges();
    
    async function openChallengeDiv(groupId) {
        setShowChallengeDiv(prev => !prev);
        setChallengeGroupId(groupId);
        setEligibleQuizzes([]); 

        try {
            const result = await getGroupOpenChallenges(groupId).unwrap();
            setEligibleQuizzes(result);
        } catch (error) {
            console.error("Error fetching group challenges:", error);
        }
    }

    async function submitChallenge(quiz, index) {
        const data = {
            quiz_id: quiz.quiz_id,
            group_id: challengeGroupId,
            user_id: quizUserInfo.id,
        }
        try {
            const challengeData = await createChallenge(data).unwrap();

            toast.success('The group has been challenged');
            setShowChallengeDiv(false);
            setShowGroup({ ...showGroup, [index]: true });
            
            await loadGroups();
            await loadChallenges();

            socket?.emit('group_event', challengeData);
        } catch (error) {
            console.error('Create challenge error:', error);
            window.alert(error?.data?.message || error.error);
        }
    }


    return (
        <>
        <h5>Challenges</h5>
                        
        {createChallengeLoading && <Loader />}
        {group.challenges.map((challenge, idx) => (
            <Row key={`${challenge}-${idx}`} className="my-1">
                <QuizLink challenge={challenge} user={quizUserInfo.username} />
            </Row>
        ))}

        <Button className="quiz-btn-dark my-4" onClick={() => openChallengeDiv(group.id)}>
                            
        {!showChallengeDiv ? (
            <>
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Create Challenge  
            </>
            ) : (
            <>
                Nevermind 
                <FontAwesomeIcon icon={faChevronUp} className="ms-1" />
            </>
            )}
        </Button>

        {!showChallengeDiv ? (
            <></>
        ) : openChallengeLoading ? (
            <Loader />
        ) : (
            <div className="choose-challenge">
            {(() => {
                if (eligibleQuizzes.length === 0) {
                return <p>There are no available quizzes for this group.</p>;
                }
            
                return eligibleQuizzes.map((quiz) => (
                <div key={`challenge-list-${quiz.quiz_id}`}>
                    <Button className="quiz-list-btn" onClick={() => submitChallenge(quiz, index)}>
                    {`${quiz.topic} | Level: ${levels[quiz.level]} | Number of Questions: ${quiz.number_questions}`}
                    </Button>
                </div>
                ));
            })()}
            </div>)}
        </>
    );
})

export default GroupChallenges